export default __webpack_public_path__ + "static/media/thunderColored.277e43ca.svg";